import { useState } from 'react'
import { FormRow, Alert } from '../../components'
import { useAppContext } from '../../context/appContext'
import Wrapper from '../../assets/wrappers/DashboardFormPage'

const Profile = () => {
    const { user, showAlert, displayAlert, updateUser, isLoading } = useAppContext();

    const [firstName, setFirstName] = useState(user?.firstName);
    const [lastName, setLastName] = useState(user?.lastName);
    const [email, setEmail] = useState(user?.email);

    const handleSubmit = (e) => {
        e.preventDefault()
        // remove while testing TODO
        // if (!name || !email || !lastName || !location) {
        //     displayAlert("Please provide all values!");
        //     return
        // }
        updateUser({ firstName, email, lastName })
    }

    return (
        <Wrapper>
            <form className='form' onSubmit={handleSubmit}>
                <h3>Profil</h3>
                {showAlert && <Alert />}
                <div className='form-center'>
                    <FormRow
                        type="text"
                        name="firstName"
                        labelText="Vorname"
                        maxLength={254}
                        value={firstName}
                        handleChange={(e) => setFirstName(e.target.value)}
                    />
                    <FormRow
                        type="text"
                        name="lastName"
                        labelText="Nachname"
                        maxLength={254}
                        value={lastName}
                        handleChange={(e) => setLastName(e.target.value)}
                    />
                    <FormRow
                        type="email"
                        name="email"
                        labelText="Email"
                        maxLength={254}
                        value={email}
                        handleChange={(e) => setEmail(e.target.value)}
                    />
                    <button className='btn btn-block' type='submit' disabled={isLoading}>
                        {isLoading ? 'Wird gespeichert...' : 'Speichern'}
                    </button>
                </div>
            </form>
        </Wrapper>
    )
}

export default Profile